module.exports = __webpack_public_path__ + "static/media/agenda-semana.2ec00664.svg";